import type { NextPage } from 'next'
import { Press } from '@/client/modules/Press'
import { PressProps } from '@/client/modules/Press/types'
import { getCMSContent } from '@/client/utils'

const PressPage: NextPage<PressProps> = (data) => <Press {...data} />

export async function getStaticProps({ defaultLocale, locale }) {
  const data = await getCMSContent(defaultLocale, locale, 'PRESS')

  if (!data?.content) return { revalidate: 60, notFound: true }

  return {
    revalidate: 10,
    props: { ...data }
  }
}

export default PressPage
